import { connect } from 'react-redux';
import { GroupsList as Component } from './GroupsList';

const mapStateToProps = ({ menu: { menuTemplates } }) => ({
  groupTypesList: menuTemplates.groupTypesList,
});

export const GroupsList = connect(mapStateToProps)(Component);
